import React, { Fragment } from 'react'
import { Row, Col, Navbar, Button, FormControl, Form, FormGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Icon } from '@iconify/react';
import facebookRect from '@iconify/icons-brandico/facebook-rect';
import '../Accueil.css'

const HeaderTop = ({ handleSubmit, handleCHange, handleSubmitFacebbok, setRedirect }) => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" className="navbar-search">
              <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                  <Row>
                      <Col lg={4} md={11} sm={11} xs={9}>
                          <Form className="navbar-form navbar-left" onSubmit={handleSubmit}>
                              <FormGroup>
                                  <FormControl type="text" placeholder="Rechercher" name="search" onChange={handleCHange} />
                              </FormGroup>
                              <Button onClick={handleSubmit}>
                                  <FontAwesomeIcon icon={faSearch} />
                              </Button>
                          </Form>
                      </Col>
                      <Col md={1} lg={{ span: 1, offset: 7 }} sm={1} xs={3}>
                      <Fragment>
                          {handleSubmitFacebbok()}
                          <Button className="icon-button" onClick={setRedirect}>
                              <Icon icon={facebookRect} />
                          </Button>
                      </Fragment>
                      </Col>
                  </Row>
              </Col>
          </Navbar>
            
        </div>
    )
};

export default HeaderTop;